export * from '@primeuix/themes/nora/inplace';
export { default } from '@primeuix/themes/nora/inplace';
